<script lang="ts">
  import { getAppConfig } from '../../../../common/config/app-config';
  import Text from '../../../common/components/Text.svelte';

  export let showGuidelines = false;

  const { lang } = getAppConfig();
</script>

<section class="guidelines-container">
  <!-- svelte-ignore a11y-invalid-attribute -->
  <a href="#" on:click={() => (showGuidelines = !showGuidelines)}>
    <Text key="extra.pdp.review.show.help.guidelines" />
  </a>
  {#if showGuidelines}
    {#if lang === 'en'}
      <div class="guidelines">
        Consider including the following:
        <ul>
          <li>Why do you like or dislike this product?</li>
          <li>How does it compare to similar products?</li>
          <li>Who would you recommend it to?</li>
        </ul>

        Try to keep your product review on topic.
        <ul>
          <li>
            <b>Don't</b> comment on the seller or delivery service, or let this affect the product rating.
          </li>
          <li>
            <b>Don't</b> include any links or personal information like addresses, phone numbers, etc.
          </li>
          <li>
            <b>Don't</b> include advertisements or references to other offers or websites.
          </li>
        </ul>

        Your review will be read by a moderator and will only be published if it meets these guidelines and our
        <a
          href="https://reviews.testfreaks.com/pages/extrastores.com/terms"
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          terms &amp; conditions</a
        >.
      </div>
    {:else}
      <div class="guidelines">
        يرجى مراعاة تضمين الآتي :
        <ul>
          <li>لماذا تحب أو تكره هذا المنتج ؟</li>
          <li>كيف يمكن مقارنته مع منتجات مشابهه ؟</li>
          <li>لمن يمكن أن توصي به ؟</li>
        </ul>
        حاول أن تحافظ على إستعراضك للمنتج ضمن الموضوع .
        <ul>
          <li>لا تعلق على البائع أو خدمة التوصيل ،أو تدع ذلك يؤثر على تصنيف المنتج</li>
          <li>لا تضمن أي إرتباطات أو معلومات شخصية كالعنوان أو رقم التلفون</li>
          <li>لا تضمن إعلانات أو مراجع لأي عروض أخرى أو مواقع الكترونية</li>
        </ul>
        سيقرأ مراجعتك مدير أو وسيط وسوف تنشر فقط إذا كان ملائما للخطوط الإرشادية المذكورة
      </div>
    {/if}
  {/if}
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .guidelines-container {
    .guidelines {
      margin-top: 8px;
      padding: 10px;
      border-radius: 8px;
      background-color: $neutral-light-04;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;

      ul {
        margin: 4px 0 10px 15px;
        list-style-type: disc;
      }
    }
    & > a {
      font-weight: 500;
      font-size: 16px;
      line-height: 18px;
      color: $icon-only-icon-blue;
      text-decoration: none;
    }
  }
</style>
